import React from "react";
import { NavLink } from "react-router-dom";
import "containers/Template/Navbar/Navbar.css";
import * as CONSTANT from "constants/text";

/**
 * @description Creates a navigatin bar to switch between pages
 * @class Navbar
 * @implements BroweserRouter as Router
 * @extends React.Component
 * @type {Navbar}
 * @example <Navbar />
 * pre-condition: all the imports
 * post-condition: returns a navigation bar
 * @param null
 * @returns {Navbar}
 */
class Navbar extends React.Component {
  render() {
    return (
      <nav className="header__nav" role="navigation">
        <ul className="nav__list">
          <NavLink
            activeClassName="nav__item--active"
            className="nav__link nav__item"
            to={"/projects"}
          >
            {" "}
            <div className="nav__icon--projects"></div>
            <div className="nav__label">
              <span style={{ paddingRight: "3px", paddingLeft: "3px" }}>
                {CONSTANT.PROJECTS}
              </span>
            </div>
          </NavLink>

          <NavLink
            activeClassName="nav__item--active"
            className="nav__link nav__item"
            to={"/spotlight"}
          >
            {" "}
            <div className="nav__icon--spotlight"></div>
            <div className="nav__label">{CONSTANT.SPOTLIGHT}</div>
          </NavLink>

          <NavLink
            exact
            activeClassName="nav__item--active"
            className="nav__link nav__item"
            to={"/"}
          >
            {" "}
            <div className="nav__icon--homepage"></div>
            <div className="nav__icon--homepage_overlay"></div>
            <div className="nav__label"> </div>
          </NavLink>

          <NavLink
            activeClassName="nav__item--active"
            className="nav__link nav__item"
            to={"/friends"}
          >
            {" "}
            <div className="nav__icon--friends"></div>
            <div className="nav__label">
              <span style={{ paddingRight: "15px", paddingLeft: "15px" }}>
                {CONSTANT.TRIBE}
              </span>
            </div>
          </NavLink>

          <NavLink
            activeClassName="nav__item--active"
            className="nav__link nav__item"
            to={"/market-coming-soon"}
          >
            {" "}
            <div className="nav__icon--market"></div>
            <div className="nav__label">
              <span style={{ paddingRight: "8px", paddingLeft: "8px" }}>
                {CONSTANT.MARKET}
              </span>
            </div>
          </NavLink>
        </ul>
      </nav>
    );
  }
}

export default Navbar;
